import React, { useState, useEffect } from 'react';
import './Countdown.css';

function Countdown({ onCountdownFinish }) {
    const [count, setCount] = useState(3);
    const [displayCount, setDisplayCount] = useState(3);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        if (count > 0) {
            const timer = setTimeout(() => {
                setCount(count - 1);
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setIsExiting(true);
            const finishTimer = setTimeout(() => {
                onCountdownFinish();
            }, 500); // Wait for fade-out animation to finish
            return () => clearTimeout(finishTimer);
        }
    }, [count, onCountdownFinish]);

    useEffect(() => {
        setDisplayCount(count);
    }, [count]);

    return (
        <div className={`countdown-overlay ${isExiting ? 'fade-out' : ''}`}>
            <div key={displayCount} className="countdown-number">{displayCount > 0 ? displayCount : ''}</div>
        </div>
    );
}

export default Countdown;

